<template>
  <v-checkbox v-model="selected" @change="setSelected" color="grey darken-2" class="list-item">
    <template v-slot:label>
      <div class="row">
        <p>
          <strong>{{ file.path }}</strong>
        </p>
        <p>size: {{ file.size }}</p>
        <p>lines: {{ file.lines }}</p>
      </div>
    </template>
  </v-checkbox>
</template>

<script>
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { ElementMixin } from "vue-slicksort";

@Component({
  mixins: [ElementMixin]
})
export default class CodeListingItem extends Vue {
  @Prop() file;
  @Prop() toggleSelected;

  selected = false;

  @Watch('toggleSelected')
  onToggleSelected() {
    this.selected = this.toggleSelected;
    this.setSelected();
  }

  setSelected() {
    this.$emit("select", {
      event: this.selected ? "add" : "remove",
      file: this.file
    });
  }

  mounted() {
    let f = this.file;
    if (f.size < 5000 && f.path.match(/(-lock|\.lock)/) === null) {
      this.selected = true;
      this.setSelected();
    }
  }
}
</script>

<style lang="scss">
.list-item {
  text-align: start;
  border: 1px solid lightgray;
  box-shadow: 0.5px 1px 3px 0px;
  border-radius: 4px;
  background-color: #fff;
  padding: 5px;
  margin: 5px;
  display: flex;
  flex-direction: column;
  p {
    margin: 0 0 0 10px;
  }
  .v-input__slot {
    margin-bottom: 0 !important;
  }
  .v-messages {
    display: none;
  }
}
</style>
